import script from "./MallMyProfilePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallMyProfilePage.vue?vue&type=script&setup=true&lang=ts"

import "./MallMyProfilePage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__